import type { getSearchVariables } from '../getSearchVariables/getSearchVariables';
import { DATERANGES } from '#lib/websites/news/constants/dateranges.js';

export const isGeotagActive = ({
	searchGeotag,
	variables,
}: {
	searchGeotag: string;
	variables: ReturnType<typeof getSearchVariables>;
}) => {
	const geotag = variables['geotag'];

	return (
		variables.daterange === DATERANGES.ALL &&
		geotag?.toLowerCase() === searchGeotag?.toLowerCase()
	);
};
